import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function updateOrder(
  _id: string,
  updatedOrder: any
): Promise<any> {
  try {
    const response = await axiosInstance.patch(
      `${config.apiUrl}/orders/${_id}`,
      updatedOrder
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error updating Order"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
